import React from 'react';
import ReactDOM from 'react-dom';
import { configureStore, history } from 'root/src/configureStore';
import App from './App';

const store = configureStore();

ReactDOM.render(<App store={store} history={history} />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js